import { apiClient } from "@/lib/api-client";
import type {
  ContactAttributeDefinition,
  CreateAttributeDefinitionPayload,
  UpdateAttributeDefinitionPayload,
} from "@/types/contacts";

class ContactAttributeDefinitionService {
  async getDefinitions(accountId: string): Promise<ContactAttributeDefinition[]> {
    return apiClient.get(`/accounts/${accountId}/contact-attribute-definitions`, { requiresAuth: true });
  }

  async createDefinition(accountId: string, data: CreateAttributeDefinitionPayload): Promise<ContactAttributeDefinition> {
    return apiClient.post(`/accounts/${accountId}/contact-attribute-definitions`, data, { requiresAuth: true });
  }

  async updateDefinition(accountId: string, id: string, data: UpdateAttributeDefinitionPayload): Promise<ContactAttributeDefinition> {
    return apiClient.put(`/accounts/${accountId}/contact-attribute-definitions/${id}`, data, { requiresAuth: true });
  }

  async deleteDefinition(accountId: string, id: string): Promise<void> {
    return apiClient.delete(`/accounts/${accountId}/contact-attribute-definitions/${id}`, { requiresAuth: true });
  }
}

export const contactAttributeDefinitionService = new ContactAttributeDefinitionService();
